// extracted by mini-css-extract-plugin
export default {"card":"A5-z"};